import React, { Fragment, useState, useEffect, useContext } from "react";
import { walletColumns, walletData } from "../../../Data/Driver/DriverWallet";
import CommonDataTable from "../../Common/Component/CommonDataTable";
import {
  getDriverPayments,
  getDriverWallet,
  getDriverWalletCount,
} from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import DataTable from "react-data-table-component";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
const DriverWallet = ({ driverId }) => {
  const [walletData, setWalletData] = useState([]);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [loader,setLoader] = useState(false)
  const {mix_background_layout} = useContext(CustomizerContext)

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const fetchDriverWallet = () => {
    setLoader(true)
    const obj = {
      driverId,
      page: pagination,
      size:rowsPerPage
    };

    getDriverWallet(obj)
      .then((result) => {
        console.log(result.data, "driverwallet");
        setLoader(false)
        if (result.data ) {
          const processData = result.data.driverEarningsList.map((element, index) => {
            return {
              amount_credited:
              element.paymentModeType === "CreditCustomer" ||
              element.paymentModeType === "CreditCard" ||
              element.paymentModeType === "onlinepayment" ||
              element.paymentModeType === "PostCredit"
                  ? element.walletAmount
                  : "-",
              date_time: element.createdOn
                ? moment(new Date(element.createdOn)).format("MMM DD HH:mm")
                : "-",
              amount_debited:
                element.paymentModeType == "Cash" && element.walletAmount
                  ? element.walletAmount
                  : "-",
              balance: element.balance ? element.balance : "-",
              megaCabsBookingNo: element.megaCabsBookingNo ? element.megaCabsBookingNo : "-",
            };
          });
          setWalletData(processData);
          setPaginationTotalRows(result.data.count);
        }
      })
      .catch((err) => {
        setLoader(false)
        showAlert("error", "Something went wrong");
      });
  };

  useEffect(() => {
    fetchDriverWallet();
  }, [pagination, rowsPerPage]);

  // useEffect(() => {
  //   fetchDriverWallet();
  //   let obj = {
  //     driverId,
  //   };
  //   getDriverWalletCount(obj).then((result) => {
  //     if (result.data) {
  //       setPaginationTotalRows(result.data);
  //     }
  //   });
  // }, []);

  return (
    <Fragment>
      <div className="table-responsive driver-wallet-table">
        <DataTable
          columns={walletColumns}
          data={walletData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={'50vh'}
          paginationPerPage={rowsPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationServer
          pagination
          progressPending={loader}
          progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
    </Fragment>
  );
};

export default DriverWallet;
